import moment from 'moment/moment';

import { STRIPE_DATE_FIELD_FORMAT } from 'constants/dateField';

export const getDateFromTimestamp = (timestamp: number, format: string | undefined = STRIPE_DATE_FIELD_FORMAT) => {
  const dateTime = moment(timestamp * 1000);
  return dateTime.format(format);
};

export default undefined;